import { Typography } from 'antd';
import styled from 'styled-components';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IColumnWidget } from './IColumnWidget.ts';

const ColumnWidgetPreviewStyled = styled.div``;

const ColumnWidgetPreviewDescription = styled.div`
  padding: 3px 6px;
`;

type IColumnWidgetProps = IWidgetComponentProps<IColumnWidget>;

export function ColumnWidgetComponent(props: IColumnWidgetProps) {
  const { widget } = props;
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(widget, options);

  if (!visible) return null;

  return (
    <ColumnWidgetPreviewStyled>
      {options.preview && (
        <ColumnWidgetPreviewDescription>
          {widget.notes && (
            <>
              <Typography.Text strong>Note: </Typography.Text>
              <Typography.Text type="secondary">{widget.notes}</Typography.Text>
            </>
          )}
        </ColumnWidgetPreviewDescription>
      )}
      <div>{props.children}</div>
    </ColumnWidgetPreviewStyled>
  );
}
